<script setup>
import { useI18n } from 'vue-i18n';
import { useCartStore } from '@/composables/stores';

const { t } = useI18n();
const cart = useCartStore();

const items = [
  { to: '/', label: 'nav.home', icon: '🏠' },
  { to: '/categories', label: 'nav.categories', icon: '🗂️' },
  { to: '/cart', label: 'nav.cart', icon: '🛒', badge: true },
  { to: '/orders', label: 'nav.orders', icon: '📦' },
  { to: '/account', label: 'nav.account', icon: '👤' }
];
</script>

<template>
  <nav class="bottom-nav" :aria-label="t('nav.home')">
    <RouterLink
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="nav-item"
      :aria-label="t(item.label)"
    >
      <span class="icon" aria-hidden="true">{{ item.icon }}</span>
      <span class="label">{{ t(item.label) }}</span>
      <em v-if="item.badge && cart.itemCount > 0" aria-label="cart count">{{ cart.itemCount }}</em>
    </RouterLink>
  </nav>
</template>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 540px;
  height: 80px;
  background: var(--surface);
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  box-shadow: 0 -10px 35px rgba(8, 61, 102, 0.16);
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
  z-index: 40;
}
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--ink-soft);
  font-weight: 600;
  position: relative;
  font-size: 11px;
  transition: color var(--t);
}
.nav-item:hover { color: var(--brand-blue); }
.nav-item.router-link-active { color: var(--brand-blue); }
.icon { font-size: 22px; }
.label { letter-spacing: 0.01em; }
em {
  position: absolute;
  top: 8px;
  inset-inline-end: calc(50% - 24px);
  background: var(--brand-red);
  color: #fff;
  border-radius: var(--radius-pill);
  font-size: 11px;
  font-style: normal;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
}
@media (max-width: 600px) { .bottom-nav { max-width: 100%; } }
</style>
